import moment from 'moment';
import PropTypes from 'prop-types';

const UserTableStatus = (props) => {
  const { data } = props;

  if (data.type === 'user') {
    return <span>{data.status}</span>;
  }

  const reInvited = moment(parseInt(data.alldata.updatedAt, 10)).diff(moment(parseInt(data.alldata.createdAt, 10)), 'minutes') > 0;

  return (
    <div className="invite-status">
      <span className="invite-label">{reInvited ? 'Re Invited' : 'Invited'}</span>
      <span className="invited-time">{data.status}</span>
    </div>
  );
};

UserTableStatus.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]),
};

export default UserTableStatus;
